// check if value (as a string) starts with given string
export const checkIfStartsWithGivenString = (valueString: string, string: string): boolean => {
  return valueString?.toLowerCase()?.replace(/\s/g, "")?.startsWith(string?.toLowerCase()?.replace(/\s/g, ""));
};
